import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';

function PricingHeader() {
  const styles = {
    hero: {
      background: 'linear-gradient(135deg, #1a365d 0%, #2C5282 100%)',
      borderRadius: '16px',
      padding: '4rem 2rem',
      color: 'white',
      marginBottom: '4rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      textAlign: 'center',
    },
    title: {
      fontSize: '3.5rem',
      fontWeight: '700',
      marginBottom: '1rem',
      background: 'linear-gradient(45deg, #ffffff 30%, #e2e8f0 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    subtitle: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      opacity: '0.9',
      maxWidth: '800px',
      margin: '0 auto',
      color: '#e2e8f0',
    },
    features: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      marginTop: '2rem',
      flexWrap: 'wrap',
    },
    feature: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      color: '#e2e8f0',
      fontSize: '1.1rem',
    },
    icon: {
      color: '#4299E1',
      fontSize: '1.2rem',
    },
  };

  return (
    <Container>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div style={styles.hero}>
          <h1 style={styles.title}>Choose Your Plan</h1>
          <p style={styles.subtitle}>
            Select the perfect plan to power your genetic research with our cutting-edge cloud infrastructure
          </p>
          <div style={styles.features}>
            <div style={styles.feature}>
              <span style={styles.icon}></span>

            </div>
            <div style={styles.feature}>
              <span style={styles.icon}></span>

            </div>
            <div style={styles.feature}>
              <span style={styles.icon}></span>

            </div>
          </div>
        </div>
      </motion.div>
    </Container>
  );
}

export default PricingHeader;
